export function getUrlParam(name, location = window.location) {
  const searchValue = new URLSearchParams(location.search).get(name);
  if (searchValue) {
    return searchValue;
  }

  const hashQuery = location.hash.includes("?")
    ? location.hash.slice(location.hash.indexOf("?") + 1)
    : "";
  return new URLSearchParams(hashQuery).get(name) || "";
}
